import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import MemoryDetailPanel from './MemoryDetailPanel'
import type { MemoryCopy, MemoryDetailPayload, MemoryRow } from './types'

interface Props {
  workerId: string
  copy: MemoryCopy
  row: MemoryRow
  detail?: MemoryDetailPayload
  loading: boolean
  canManage: boolean
  onMutated: () => void
  onSelectSource: (documentId: string) => void
  onClose: () => void
}

export default function MemoryDetailDialog({ workerId, copy, row, detail, loading, canManage, onMutated, onSelectSource, onClose }: Props) {
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent className="h-[min(760px,calc(100vh-2rem))] max-w-2xl gap-0 overflow-hidden bg-card p-0 sm:rounded-xl [&>button]:hidden">
        <DialogTitle className="sr-only">{copy.detail.title}</DialogTitle>
        <MemoryDetailPanel workerId={workerId} copy={copy} row={row} detail={detail} loading={loading} canManage={canManage} onMutated={onMutated} onSelectSource={onSelectSource} onClose={onClose} />
      </DialogContent>
    </Dialog>
  )
}
